import * as React from 'react';
import { useDispatch } from 'react-redux';
import { trySilentGetAppConfig } from '../actions/appConfig';

const AppConfigContainer: React.FC = () => {
    const dispatch = useDispatch();

    const appConfigPollingInterval = 300000; // 5 minutes in ms

    // fetch config
    React.useEffect(() => {
        dispatch(trySilentGetAppConfig());
    }, []);

    // setup regular polling for config changes
    React.useEffect(() => {
        const intervalId = setInterval(() => {
            dispatch(trySilentGetAppConfig());
        }, appConfigPollingInterval);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    return null;
};

export default AppConfigContainer;
